#### Change to Content-Disposition filenames on attachment downloads

From 1 November 2026, the SEEK API will format the `Content-Disposition` header on attachment downloads in line with [RFC 6266].

**What is changing?**

The original filename will still be provided in the `Content-Disposition` header.
For simple filenames that do not contain spaces or special characters, quotes may be omitted.

For example:

```http
attachment; filename="Resume.pdf"
```

may be sent as:

```http
attachment; filename=Resume.pdf
```

Filenames with spaces or special characters will remain quoted.
Non-ASCII filenames will continue to include the `filename*` parameter.

**Why is this changing?**

Quotes around a simple filename are optional under [RFC 6266].
This change aligns attachment downloads with that standard.

**What change is required for partners?**

No change is required if your integration already parses `Content-Disposition` with a library or framework that supports [RFC 6266].

If your integration assumes the filename is always quoted, you must update it to parse the header per RFC 6266.
Otherwise, hirers may receive attachments with the wrong filename or file type once this change is in effect.

See [application export attachments] and [Apply with SEEK download resume] for the documented guidance.

[RFC 6266]: https://datatracker.ietf.org/doc/html/rfc6266
[application export attachments]: /use-cases/application-export/attachments#content-disposition
[Apply with SEEK download resume]: /use-cases/apply-with-seek/download-resume#content-disposition
